<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SkistarResorts',
  methods: {
    ...mapActions({
      chooseResort: 'skistar/chooseResort',
    }),
  },
  computed: {
    ...mapState({
      resorts: state => state.skistar.resorts.items,
      resortsLoading: state => state.skistar.resorts.itemsLoading,
    }),
  },

};
</script>

<template>
    <v-container fluid>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>{{ $t('skistar.resorts.title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-progress-linear v-if="resortsLoading" :indeterminate="true"></v-progress-linear>
            <v-list v-else>
              <template v-for="(resort, index) in resorts">
                <v-divider v-if="index" :key="index"></v-divider>
                <v-list-tile @click="chooseResort(resort.id)" :key="resort.name">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="resort.name"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skistar/SkistarResorts.vue